import { COMPANY_FINISHED_SETUP } from "queries/neoFact/settings";
import { clientNeoFact } from "@neonumy/api-clients";
import { useTranslation } from "react-i18next";
import { FaCheckCircle } from "react-icons/fa";
import { useMutation } from "@apollo/client";
import { useParams } from "react-router-dom";
import { Button, notification } from "antd";
import { routes } from "config/routes";

export default function Finish() {
  const { t } = useTranslation();
  const urlParams: RouteParams = useParams();

  const [companyFinishedSetup] = useMutation<
    CompanyFinishedSetupResponse,
    CompanyFinishedSetupVars
  >(COMPANY_FINISHED_SETUP, {
    client: clientNeoFact,
  });

  const handleOnClick = async () => {
    const response = await companyFinishedSetup({ variables: { companyId: urlParams.companyId } });
    let errors: ErrorType[] = [];

    errors = response?.data?.companyFinishedSetup?.errors ?? [];

    if (errors && errors?.length > 0) {
      errors.forEach(item => {
        item.messages.forEach(message => {
          return notification.error({
            message: t("Unexpected error"),
            description: message,
            placement: "bottomLeft",
          });
        });
      });
    } else {
      routes.navigate(`/company/${urlParams?.companyId}/dashboard`);
    }
  };

  return (
    <div className="finish-success">
      <div className="finish-success-card">
        <div className="finish-success-icon">
          <FaCheckCircle />
        </div>
        <h1 className="finish-success-heading">{t("You're all set!")}</h1>
        <p className="finish-success-subtitle">
          {t("Your workspace is configured and ready to go. Start exploring your dashboard.")}
        </p>
        <Button onClick={handleOnClick} type="primary" size="large" className="finish-cta-btn">
          {t("Go to Dashboard")}
        </Button>
      </div>
    </div>
  );
}
